import React, { Fragment, useEffect, useState } from "react";
import { ReactComponent as SearchIcon } from "assets/images/common/svgs/search.svg";
import { ReactComponent as DeleteIcon } from "assets/images/common/svgs/deleteIconTable.svg";
import { ReactComponent as EyeIcon } from "assets/images/common/svgs/eyeIconTable.svg";
import { ReactComponent as NotificationRedIcon } from "assets/images/common/svgs/notificationRedIcon.svg";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import { useNavigate } from "react-router-dom";
import { confirmationPopup } from "utils/helpers/common/alert-service";
import useUsers from "containers/user-management/useHooks";
import { UserFiltersDTO } from "utils/helpers/models/common/user-filters.dto";
import Pagination from "components/particles/table/pagination";
import { ROLES } from "utils/helpers/enums/roles.enum";
import DataNotFound from "components/particles/table/data-not-found";
import { useSelector } from "react-redux";
import { USER_STATUSES } from "utils/helpers/enums/shared.enum";
import { UserDTO } from "utils/helpers/models/users/user.dto";
import { useDebounce } from "hooks/useDebounce";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { NotificationWhiteIcon } from "assets/images/common/svgs";

import { sitePermissions } from "utils/helpers/enums/permissions.enum";
import useStore from "hooks/useStore";

const Ambassadors: React.FC = () => {
  const { hasPermission } = useStore();
  const navigate = useNavigate();
  const [data, setData] = useState<UserDTO[]>([]);
  const { getUsers, activateUser, deactivateUser } = useUsers();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [filters, setFilters] = useState<UserFiltersDTO>(new UserFiltersDTO());
  const [totalElements, setTotalElements] = useState<number>(0);
  const debounceSearch = useDebounce(filters.nameOrEmail, 1000);
  const columns: string[] = [
    "Profile",
    "First Name",
    "Last Name",
    "Email",
    "City",
    "Status",
    "Action",
  ];

  const buildUpdatedFilters = (
    updates: Partial<UserFiltersDTO> = {},
    resetPage: boolean = false
  ) => {
    const updatedFilters = { ...filters, ...updates };
    if (resetPage) {
      updatedFilters.page = 1;
    }
    return updatedFilters;
  };

  const handleDelete = async (id: number) => {
    const result = await confirmationPopup();
    if (result.isConfirmed) {
      // const queryParams = {
      //   page: 1,
      //   search
      // }
      // deleteOrganization(id, setData, queryParams, setFilters);
    }
  };

  const onPageChange = (pageInfo: { selected: number; limit: number }) => {
    const { selected: page, limit } = pageInfo;
    const updatedFilters = buildUpdatedFilters(
      { limit: limit, page: page + 1 },
      false
    );
    setFilters(updatedFilters);
    getAmbassadors(updatedFilters);
  };

  const getAmbassadors = (filters: UserFiltersDTO) => {
    const filtersToSend: any = {};
    for (let key in filters) {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
        filtersToSend[key] = filters[key];
      }
    }
    const queryParams = {
      ...filtersToSend,
      page: filters.page - 1,
      role: ROLES.AMBASSADOR,
    };
    getUsers(setData, queryParams, setFilters, setTotalElements);
  };

  useEffect(() => {
    getAmbassadors(filters);
  }, [debounceSearch]);

  const handleChangeFilter = (event: any) => {
    const {
      target: { name, value },
    } = event;
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    const updatedFilters = buildUpdatedFilters(
      { [name]: trimmedValue },
      true
    );
    setFilters(updatedFilters);
    if (name === "nameOrEmail" && trimmedValue === "") {
      getAmbassadors(updatedFilters);
    }
  };

  const resetFilters = () => {
    const updatedFilters = buildUpdatedFilters(new UserFiltersDTO(), true);
    setFilters(updatedFilters);
    getAmbassadors(updatedFilters);
  };

  const handleSearch = (event: any) => {
    const { key } = event;
    if (key === "Enter") {
      const updatedFilters = buildUpdatedFilters({}, true);
      setFilters(updatedFilters);
      getAmbassadors(updatedFilters);
    }
  };

  const handleChangeStatus = async (user: any, index: number) => {
    const { id: userId, active } = user;
    const result = await confirmationPopup(
      `Are you sure you want to ${
        active ? "Deactivate" : "Activate"
      } this user?`
    );
    if (result.isConfirmed) {
      if (active) {
        deactivateUser(userId);
      } else {
        activateUser(userId);
      }
      user.active = !user.active;
      data[index] = user;
      setData([...data]);
    }
  };

  const goToDetail = (userId: number) => {
    navigate(`${siteRoutes.viewAmbassador}?id=${userId}`);
  };

  const pendrequstsCount = Number(localStorage.getItem("pendrequstsCount"));

  return (
    <div className="">
      <h1 className="tex-2xl sm:text-[32px] text-primaryText font-bold mb-6">
        Ambassadors
      </h1>
      <div className="flex flex-wrap justify-between  items-center gap-5 ">
        <div className="flex flex-wrap items-center gap-3">
          {hasPermission(sitePermissions.ambassadorRequestList) && (
            <button
              onClick={() => {
                navigate(siteRoutes.allRequests);
              }}
              className="px-4 py-2 text-sm bg-darkSlateBlueBg text-white  rounded-lg font-semibold flex gap-1 items-center"
            >
              {/* {data.pendrequstsCount} */}
              {pendrequstsCount > 0 ? (
                <NotificationRedIcon className="w-4 h-4" />
              ) : (
                <NotificationWhiteIcon className="w-4 h-4" />
              )}
              View Requests
            </button>
          )}
          {/* {hasPermission(sitePermissions.ambassadorExperiencesList) && ( */}
          <button
           className="px-4 py-2 text-sm bg-darkSlateBlueBg text-white  rounded-lg font-semibold flex gap-1 items-center"
            onClick={() => {
              navigate(siteRoutes.ambassadorExperiencesListing);
            }}
          >
            Ambassador Experiences
          </button>
          {/* )} */}
        </div>

        {/* Search Input */}
        <div className="w-full sm:w-[388px] relative">
          <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-primaryText text-lg" />
          <input
            type="search"
            placeholder="Search by Name or Email"
            value={filters.nameOrEmail}
            onChange={handleChangeFilter}
            onKeyUp={handleSearch}
            name="nameOrEmail"
            className="w-full search-input pl-10 p-2 border-[0.6px] border-borderLightGray rounded-full focus:outline-none bg-coolLightGrayBg"
          />
        </div>
      </div>
      <div className="bg-coolLightGrayBg border  border-borderLightGray p-4 rounded-lg w-full my-6">
        <div className="w-full overflow-x-auto scrollbar-hidden">
          <div className="flex flex-wrap sm:flex-nowrap lg:justify-end items-center gap-3">
            {/* City  */}
            <input
              type="text"
              value={filters.city}
              onChange={handleChangeFilter}
              placeholder="Enter City"
              name="city"
              className="px-3 border border-lightGrayBorder text-primaryText placeholder-primaryText outline-none rounded-lg text-sm bg-white h-[46px] w-full sm:w-auto min-w-[140px]"
            />

            {/* Status  */}
            <select
              value={filters.status}
              onChange={handleChangeFilter}
              name="status"
              className="px-3 border border-lightGrayBorder text-primaryText outline-none rounded-lg text-sm bg-white h-[46px] w-full sm:w-auto min-w-[140px]"
            >
              <option value="">Status</option>
              {Object.values(USER_STATUSES).map((status, index) => {
                return (
                  <option value={status} key={index}>
                    {status.toUpperCase()}
                  </option>
                );
              })}
            </select>

            {/* Apply Filters Button */}
            <button
              onClick={() => getAmbassadors(filters)}
              className="px-4 py-2 bg-darkTealBlue text-white rounded-lg text-sm h-[46px] w-full md:w-auto min-w-[140px]"
            >
              Apply Filters
            </button>

            {/* Clear Filters Button */}
            <button
              onClick={resetFilters}
              className="px-4 py-2 bg-techGlowBg text-primaryText rounded-lg text-sm h-[46px] w-full md:w-auto min-w-[140px]"
            >
              Clear Filter
            </button>
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col gap-4">
        <div className="bg-white rounded-t-lg  border border-mediumGrayBorder overflow-x-auto">
          <table className="min-w-full divide-y divide-mediumGrayBorder">
            {/* Table Header */}
            <thead className="bg-white">
              <tr className="text-left">
                {columns.map((column, index) => {
                  return (
                    <th
                      className="px-4 py-4 text-sm font-bold text-left text-primaryText whitespace-nowrap"
                      key={index}
                    >
                      {column}
                    </th>
                  );
                })}
              </tr>
            </thead>

            {/* Table Body */}
            <tbody className="bg-white divide-y divide-mediumGrayBorder">
              {data.map((user: any, index: number) => (
                <tr key={index} className="hover:bg-gray-50 ">
                  <td className="px-4 py-4">
                    <img
                      className="rounded-full w-9 h-9 object-cover"
                      src={
                        user?.profilePic
                          ? concatPathWithBackendUrl(
                              user?.profilePic?.fileDownloadUri
                            )
                          : editProfilePicUser
                      }
                    />
                  </td>
                  <td className="px-4 py-4 text-sm text-primaryText font-semibold whitespace-nowrap">
                    {user.firstName}
                  </td>
                  <td className="px-4 py-4 text-sm text-primaryText font-semibold whitespace-nowrap">
                    {user.lastName}
                  </td>
                  <td className="px-4 py-4 text-sm text-primaryText font-semibold whitespace-nowrap">
                    {user.email}
                  </td>
                  <td className="px-4 py-4 text-sm text-primaryText font-semibold whitespace-nowrap">
                    {user.city}
                  </td>

                  <td className="px-4 py-4 text-sm font-semibold whitespace-nowrap">
                    {hasPermission(sitePermissions.ambassadorUpdate) ? (
                      <label className="switch-field">
                        <input
                          type="checkbox"
                          checked={user?.active}
                          onChange={() => handleChangeStatus(user, index)}
                        />
                        <span className="slider"></span>
                      </label>
                    ) : (
                      <label className="switch-field cursor-not-allowed opacity-60">
                        <input
                          type="checkbox"
                          checked={user?.active}
                          disabled
                        />
                        <span className="slider slider-disabled"></span>
                      </label>
                    )}
                  </td>

                  <td className="px-4 py-4 text-left whitespace-nowrap w-[124px]">
                    <div className="flex justify-start gap-2 ">
                      {hasPermission(sitePermissions.ambassadorRead) ? (
                        <button onClick={() => goToDetail(user.id)}>
                          <EyeIcon />
                        </button>
                      ) : (
                        <span className="cursor-not-allowed">
                          <EyeIcon />
                        </span>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Fragment>
          <DataNotFound show={!isLoading && !data.length} />
          {totalElements > 0 && (
            <Pagination
              count={totalElements}
              page={filters.page}
              limit={filters.limit}
              onPageChange={onPageChange}
            />
          )}
        </Fragment>
      </div>
    </div>
  );
};

export default Ambassadors;
